import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoginAttemptService {
  private readonly STORAGE_KEY = 'login_attempts';
  private readonly MAX_ATTEMPTS = 5;

  constructor() {}

  getFailedAttempts(): number {
    const attempts = localStorage.getItem(this.STORAGE_KEY);
    return attempts ? parseInt(attempts, 10) : 0;
  }

  incrementFailedAttempts(): number {
    const currentAttempts = this.getFailedAttempts();
    const newAttempts = currentAttempts + 1;
    localStorage.setItem(this.STORAGE_KEY, newAttempts.toString());
    return newAttempts;
  }

  resetFailedAttempts(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }

  shouldShowCaptcha(): boolean {
    return this.getFailedAttempts() >= this.MAX_ATTEMPTS;
  }

  getRemainingAttempts(): number {
    const failed = this.getFailedAttempts();
    return Math.max(0, this.MAX_ATTEMPTS - failed);
  }
}
